<template>
    <aside class="sidebar" :class="{ 'sidebar--collapsed': collapsed }">
        <button
            type="button"
            class="sidebar__toggle"
            :title="collapsed ? 'Розгорнути меню' : 'Згорнути меню'"
            @click="toggleCollapse"
        >{{ collapsed ? '»' : '«' }}</button>

        <div class="sidebar__menu" v-show="!collapsed">
            <el-menu :default-active="activeMenuIndex" @select="onSelect">
            <!-- <el-menu-item title="Заготовка" index="/template">
                Заготовка
            </el-menu-item>  -->
                <el-menu-item v-if="userStore.user.role.name === '@developer'"  title="Ресурси" index="/catering/resources">
                    Ресурси
                </el-menu-item>

                <el-menu-item title="Налаштування" index="/catering/mainConfig">
                    Налаштування
                </el-menu-item>
                <el-menu-item title="Персонал" index="/catering/personnel">
                    Персонал
                </el-menu-item>
                <el-menu-item title="Контрагенти" index="/catering/clients">
                    Контрагенти
                </el-menu-item>
                <el-menu-item title="Артикули" index="/catering/articles">
                    Артикули
                </el-menu-item>
                <el-menu-item title="Перелік страв" index="/catering/dishes">
                    Страви
                </el-menu-item>
                <el-menu-item title="Замовлення" index="/catering/orders">
                    Замовлення
                </el-menu-item>
            </el-menu>
        </div>
        <SidebarAccountFooter :collapsed="collapsed" />
    </aside>
</template>

<script setup>
//  <el-menu default-active="" router>     

import {ElMenu, ElMenuItem} from "element-plus"
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth.js'
import SidebarAccountFooter from '@/components/SidebarAccountFooter.vue'

const userStore = useAuthStore()

const router = useRouter()
const route = useRoute()
const SIDEBAR_COLLAPSE_KEY = 'cateringSidebarCollapsed'
function readCollapsed() {
    try { return localStorage.getItem(SIDEBAR_COLLAPSE_KEY) === '1' } catch (e) { return false }
}
const collapsed = ref(readCollapsed())
function toggleCollapse() {
    collapsed.value = !collapsed.value
    try { localStorage.setItem(SIDEBAR_COLLAPSE_KEY, collapsed.value ? '1' : '0') } catch (e) {}
}

function onSelect(path) {
    const target = path.split('/').filter(Boolean).pop()
    if (!userStore.can({res:target,act:"open"})){
        return
    }
    router.push(path)
}

const CATERING_CONFIG_SUBPAGES = ['rights', 'payForms', 'categories', 'roles', 'units', 'foodClaims', 'complexTypes']
const activeMenuIndex = computed(() => {
    if (!route.path.startsWith('/catering')) return ''
    const seg = route.path.split('/').filter(Boolean).pop()
    if (CATERING_CONFIG_SUBPAGES.includes(seg)) return '/catering/mainConfig'
    return route.path
})

</script>
<style scoped lang="scss">
     .sidebar {
         display: flex;
         flex-direction: column;
         height: 100%;
         border-right: 1px solid #ffbf1f;
         flex: 0 0 280px;
         width: 280px;
         min-width: 280px;
         max-width: 280px;
         box-sizing: border-box;
         overflow: hidden;
         padding: 0 10px;
         transition: flex-basis .15s ease, width .15s ease, min-width .15s ease;

         &--collapsed {
             flex: 0 0 40px;
             width: 40px;
             min-width: 40px;
             max-width: 40px;
             padding: 0 4px;
         }
     }

     .sidebar__toggle {
         flex: 0 0 auto;
         align-self: flex-end;
         margin-top: 10px;
         width: 26px;
         height: 26px;
         border: 1px solid #ffbf1f;
         border-radius: 4px;
         background: #fff;
         color: #b8860b;
         font-size: 14px;
         line-height: 1;
         cursor: pointer;
     }

     .sidebar--collapsed .sidebar__toggle {
         align-self: center;
         margin-top: 10px;
     }

     .sidebar__menu {
         flex: 1 1 auto;
         min-height: 0;
         min-width: 0;
         overflow: hidden;
     }
       
         :deep(.el-menu) {
             flex: 1;
             background-color: #fff;
             color: var(--el-color-primary);
             border-right: none;
             border-radius: 0;            
             :deep(&-vertical-demo) {
                 border-right: none;
             }
             
             .el-menu-item:hover{
                color:   var(--el-menu-active-color);
             }

             .el-menu-item,
             .el-sub-menu__title {
                 height: 35px;
                &.is-active {
                     color:   var(--el-menu-active-color); 
                     font-weight: bold;
                }         
            }
         }



</style>
